import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class SharedService {
  showLoader: Boolean = false;
  throwSnackBar = false;
  snackBarMessage = '';
  snackBarType: 'success' | 'error' | 'warning' = 'success';
  snackBarTimeout = null;
  showNavBar: Boolean = false;
  constructor() { }
  displaySnackBar(message, msgType) {
    this.snackBarType = msgType;
    this.snackBarMessage = message;
    this.throwSnackBar = true;

    if (this.snackBarTimeout) {
      clearTimeout(this.snackBarTimeout);
    }

    this.snackBarTimeout = setTimeout(() => {
      this.throwSnackBar = false;
      clearTimeout(this.snackBarTimeout);
      this.snackBarTimeout = null;
    }, 3000);
  }

  displaySuccessMsg(message) {
    this.displaySnackBar(message, 'success');
  }

  displayWarningMsg(message) {
    this.displaySnackBar(message, 'warning');
  }

  displayErrorMsg(message) {
    this.displaySnackBar(message, 'error');
  }
  prepareString(str, ...arg) {
    arg.map((item, index) => {
      str = str.replace('*', item);
    });
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts